@if (tenant) {
	<app-tenants-form [tenant_]="tenant" />
}
